import React from 'react'
import "./styles.scss";

export const Required = () => {
  return (
    <span className='required-gtc-rc'>*</span>
  )
}